import React, {Suspense} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Planner from './Planner';
// import MapView from './MapView';
import Directions from './Directions';
import Spinner from './shared/Spinner';
import { IconAlert } from './Icons';
import {loadConfig} from '../actions';

// eslint-disable-next-line
const Map = React.lazy(() => import('./Map'));

class App extends React.Component {

    componentDidMount() {
        if (!window.otpConfig) {
            this.props.loadConfig({error: 'NO_CONFIG', loading: false});
            return;
        }
        const config = window.otpConfig;
        if (!config.mapboxToken) {
            this.props.loadConfig({...config, error: 'NO_TOKEN', loading: false});
            return;
        }
        this.props.loadConfig({...config, loading: false});
    }
    
    // The planner-only view, when map is not enabled and
    // there are no directions yet
    
    renderPlannerView() {
        return (
            <div className="otp-single-col-container">
                <div className="otp-center-col">
                    <Planner />
                </div>
            </div>
        );
    }

    // The view for planner and directions if map is enabled
    renderMapView() {
        return (
            <div className="otp-two-col-container otp-has-map">
                <div className="otp-left-col">
                    <Planner />
                    <Directions />
                </div>
                <br/>
                <div className="otp-right-col">
                    <Suspense fallback={<Spinner />}>
                        <Map />
                    </Suspense>
                </div>
            </div>
        );
    }

    // The directions view, once trips are loaded, and no
    // map. Also shows on directions load or error
    renderDefaultDirections() {
        return (
            <div className="otp-two-col-container">
                <div className="otp-left-col">
                    {(this.props.config.error === 'NO_TOKEN') &&
                    <p><IconAlert /> Unable to show map.</p>
                    }
                    <Planner />
                </div>
                <div className="otp-right-col">
                    <Directions />
                </div>
            </div>
        );
    }

    renderErrorPage() {
        return (
            <div className="otp-single-col-container">
                <div className="otp-center-col">
                    <h2><IconAlert /> Error: Missing Configuration</h2>
                    <p>
                        Open Trip Planner must be configured in order to use. Please set up a config
                        accessible from window.otpConfig. See the Github readme for more information on
                        configuration options.
                    </p>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.config.loading) {
            return <Spinner />;
        }
        if (this.props.config.error) {
            const {error} = this.props.config;
            if (error === 'NO_CONFIG') {
                return this.renderErrorPage();
            }
            if (error === 'NO_TOKEN') {
                return this.renderDefaultDirections();
            }
        }
        if (this.props.view === 'MAP') {
            return this.renderMapView();
        }
        if (this.props.view === 'DIRECTIONS') {
            return this.renderDefaultDirections();
        }
        if (this.props.view === 'PLANNER') {
            return this.renderPlannerView();
        }
        
    }
}
const mapStateToProps = state => {
    return {
        view: state.view.currentView,
        config: state.config
    };
};
const mapDispatch = dispatch => {
    return bindActionCreators({loadConfig}, dispatch);
};

export default connect(mapStateToProps, mapDispatch)(App);